
import TokenInList from './tokeninlist'

export default TokenInList;
